import { render, staticRenderFns } from "./Mars.vue?vue&type=template&id=28e24d14&"
import script from "./Mars.vue?vue&type=script&lang=js&"
export * from "./Mars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports